var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-caselist-page-case"},[_c('div',{staticClass:"mobile-caselist-header-box"}),_c('ContentBottom',{attrs:{"list":_vm.imgData},on:{"toInfo":_vm.toInfo}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }